import type { GraphNode } from '../../types/transit'

// The workspace's views that aren't sections (?node=), listed after them in
// this order; Generate package last, as the last step.
export const READINESS = '__readiness__'
export const MAP = '__map__'
export const PACKAGE = '__package__'

/** A transition's sections as the UI lists them (front_end_display_order: the
 *  capability first and the summary last, as they draft). The graph comes in
 *  document order, which the package and the Map keep. */
export function inDisplayOrder(nodes: GraphNode[]): GraphNode[] {
  return [...nodes].sort((a, b) => a.front_end_display_order - b.front_end_display_order)
}
